// extracted by mini-css-extract-plugin
export default {"navLink":"styles_navLink__8X98N","active":"styles_active__m6DGY"};